module.exports = __webpack_public_path__ + "img/newCand-line-icon.8e1bf9dd.svg";